import { formatInHoursAndMinutes } from '~/routes/utils';

export const makeMultipleOfFifteen = (appointmentTimeInMinutes) => {
  const reminder = appointmentTimeInMinutes % 15;
  return reminder ? appointmentTimeInMinutes + 15 - reminder : appointmentTimeInMinutes;
};

export const getEstimationTimeForAllProducts = (products) => {
  let maxAdminTime = 0;
  const appointmentTimeInMinutes =
    products.reduce((acc, { activityTime, adminTime, quantity, selectionType }) => {
      const selectionTypeActivityTime = selectionType ? selectionType.activityTime : 0;
      maxAdminTime = adminTime > maxAdminTime ? adminTime : maxAdminTime;
      return acc + (activityTime + selectionTypeActivityTime) * quantity;
    }, 0) + maxAdminTime;

  return formatInHoursAndMinutes(makeMultipleOfFifteen(appointmentTimeInMinutes));
};

export const getDefaultOption = (label) => ({
  label,
  value: '',
  id: `default-for-${label.replace(/ /g, '-').toLowerCase()}`,
  key: `default-for-${label.replace(/ /g, '-').toLowerCase()}`,
  hidden: true,
  disabled: true,
});

export const getProductTypes = (products) =>
  products.map((product) => ({
    label: product.name,
    value: product.id,
    id: product.id,
    key: product.id,
  }));

export const getProductTypesOptions = (products, labelForDefaultOption) => {
  const productsList = getProductTypes(products);

  return [getDefaultOption(labelForDefaultOption), ...productsList];
};

export const getProductSelectionTypesOptions = (products, labelForDefaultOption) => {
  const productsList = getProductTypes(products);

  return !labelForDefaultOption
    ? productsList
    : [getDefaultOption(labelForDefaultOption), ...productsList];
};

export const getNumericArrayFromTo = (from, to) =>
  Array.from({ length: to }, (item, index) => index + 1);
